import React, { useState } from 'react';
import { SubscriptionSummary } from '../../../types/subscription';
import { Transaction } from 'grts-utils/types/Transaction';
import SummaryChart from './Chart';
import OverviewChartTimeframeSelector from './OverviewChartTimeframeSelector';
import SummaryInformation from './Info';
import { SummaryInformation as SummaryInformationType } from '../types';
import OverviewChartTypeSelector from './OverviewChartTypeSelector';
import useWidthBreakpoint from '../../../hooks/useWidthBreakpoint';

interface Props {
  totalValue: number;
  subscriptions: SubscriptionSummary[];
  transactions: Transaction[];
}

const Summary: React.FC<Props> = (props: Props) => {
  const { subscriptions, totalValue } = props;

  const { breakpoint } = useWidthBreakpoint();
  const [summaryInformation, setSummaryInformation] = useState<
    SummaryInformationType | undefined
  >();

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        flex: 1,
        flexDirection: breakpoint === 'sm' ? 'column-reverse' : 'row',
      }}
    >
      <SummaryInformation
        subscriptions={subscriptions}
        summaryInformation={summaryInformation}
      />
      <div
        style={{
          flex: breakpoint === 'sm' ? 'auto' : 1,
          height: breakpoint === 'sm' ? 500 : '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginRight: 16,
          marginTop: 8,
        }}
      >
        <SummaryChart
          subscriptions={subscriptions}
          setSummaryInformation={setSummaryInformation}
          totalValue={totalValue}
        />
        <div
          style={{
            display: 'flex',
            justifyContent: breakpoint === 'sm' ? 'start' : 'space-evenly',
            alignItems: 'center',
            flexWrap: 'wrap',
            marginTop: 18,
            marginBottom: 12,
            columnGap: 24,
            rowGap: 12,
          }}
        >
          <OverviewChartTimeframeSelector />
          <OverviewChartTypeSelector />
        </div>
      </div>
    </div>
  );
};

export default Summary;
